import { useQuery } from '@hooks/reactQuery';

import { getAssetsListDropdown } from '@api/assets';

import {
	IAssetDropdown,
	IGetAssetsListDropdownDTO,
	TAssetsListDropdownResponse,
} from '@interfaces/assets/dto/assetsDTO';

import { ASSETS_LIST_DROPDOWN } from '@constants/queryKeys';

interface IUserQueryAssetsListDropdownReturnValue {
	assets: IAssetDropdown[];
	count?: number;
	isLoadingAssets: boolean;
}

export function useQueryAssetsListDropdown(params: IGetAssetsListDropdownDTO): IUserQueryAssetsListDropdownReturnValue {
	const {
		ownerId,
		isOwnOnly,
		page = 1,
		pageSize = 10,
		sortDirection = true,
		sortFieldName = 'assetId',
		searchValue,
	} = params;

	const { data, isInitialLoading } = useQuery<TAssetsListDropdownResponse>({
		queryKey: [
			ASSETS_LIST_DROPDOWN,
			ownerId,
			isOwnOnly,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
		],
		queryFn: () => getAssetsListDropdown(params),
		enabled: [ownerId],
	});

	return {
		assets: data?.items || [],
		count: data?.count,
		isLoadingAssets: isInitialLoading,
	};
}
